// removed by extract-text-webpack-plugin
module.exports = {"tooltip-div":"tooltip-div","table":"table","dark-tooltip":"dark-tooltip","north":"north","south":"south","west":"west","medium":"medium","dark":"dark","tip-body":"tip-body"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Unit/newToolTip.scss
// module id = 253
// module chunks = 0